import React from 'react'
import NotificationsIcon from '@mui/icons-material/Notifications';
import { IconButton } from '@mui/material';
import Badge from '@mui/material/Badge';

const Notification = ({notifCount}) => {
  return (
    <div>
<IconButton color="inherit" className="ms-auto">
  <Badge
   badgeContent={notifCount} 
color="error">
    <NotificationsIcon />
  </Badge>
</IconButton>
    </div>
  )
}

export default Notification
